/**
 * Shared status-challenge styles, decoupled from the page-route module so
 * layout/section components don't depend on `app/(app)/challenge/...`.
 *
 * `linearGradientContainer` is the status-challenge "silver shimmer" surface
 * used by the promotion banner and header CTA (ChallengeContainer,
 * ChallengePromotionBanner, RightContainer).
 */
export const linearGradientContainer = {
  border: "1px solid rgba(255, 255, 255, 0.53)",
  background: "var(--gradient-status-challenge)",
};
